import React from 'react';
import Utility from '../../../../util/utilityfunctions';
import Moment from 'moment';
import {useSelector} from 'react-redux';
import {useUserPreferences} from '../../../../util/customHooks';

const DocumentModifiedDateCellRenderer = (params) => {
	const documentsLastModifiedInformation = useSelector((state) => state.documentsLastModifiedInformation);
	const userPreferences = useUserPreferences();

	const getDocumentLatestModifiedDateTime = (document) => {
		let modifiedDate;
		const dateTimeFormat = 'YYYY-MM-DD';
		const documentLastModifiedData = documentsLastModifiedInformation.find((doc) => {
			return doc.documentId === document?.id;
		});

		modifiedDate =
			documentLastModifiedData && documentLastModifiedData?.modifiedDate
				? documentLastModifiedData?.modifiedDate
				: document?.modifiedDate;
		return Moment.utc(modifiedDate).format(dateTimeFormat);
	};

	const getLocalModifiedDateTime = (modifiedDate) => {
		const userDateTimeFormat = Utility.getUserPreferencesDateValue(userPreferences);
		const dateAndTime = Moment.utc(modifiedDate)
			.locale(Utility.getLocale(userPreferences))
			.local()
			.format(userDateTimeFormat);
		return Utility.getLocalizedFormattedDateTime(dateAndTime);
	};
	return (
		<div>
			<section className="lastModifiedDateValue">
				{getLocalModifiedDateTime(getDocumentLatestModifiedDateTime(params.data))}
			</section>
		</div>
	);
};

export default DocumentModifiedDateCellRenderer;
